import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import useRespondToConcern from "../lib/respondToConcern";
import { FaArrowLeft } from "react-icons/fa";
import { FaXmark } from "react-icons/fa6";
import "./Concerns_details.css";

export default function Concernsdetails() {
  const navigate = useNavigate();
  const location = useLocation();
  const [respondToConcern, setRespondToConcern] = useState(false);
  const [responseText, setResponseText] = useState("");
  const { respond, loading, error, successMessage } = useRespondToConcern();
  const [showClosedMsg, setShowClosedMsg] = useState(false);

  const concern = location.state;

  if (!concern) {
    return <p>Concern not found!</p>;
  }

  return (
    <>
      {respondToConcern && (
        <div className="respond-to-concern-overlay">
          <form
            onSubmit={async (e) => {
              e.preventDefault();
              try {
                await respond(concern._id, responseText);
                setTimeout(() => {
                  setRespondToConcern(false);
                }, 5000);
              } catch (error) {}
            }}
          >
            <span>
              <h3>Respond to Concern</h3>
              <FaXmark
                style={{ fontSize: "24px", cursor: "pointer" }}
                onClick={() => setRespondToConcern(false)}
              />
            </span>
            <textarea
              required
              value={responseText}
              onChange={(e) => setResponseText(e.target.value)}
              placeholder="Enter your response here..."
            />
            <button type="submit" disabled={loading}>
              {loading ? "Responding..." : "Respond"}
            </button>
            {error && <p className="errors">{error}</p>}
            {successMessage && <h3 className="success">{successMessage}</h3>}
          </form>
        </div>
      )}

      <div className="concerns-details">
        <div className="header">
          <span>
            <FaArrowLeft
              style={{ fontSize: "18px", cursor: "pointer" }}
              onClick={() => navigate("/allcustomerconcern")}
            />
            <h3>Ticket Code: {concern.ticketCode}</h3>
          </span>
          <p>
            Date Submitted: {new Date(concern.createdAt).toLocaleDateString()}
          </p>
        </div>

        <div className="info">
          <div className="card">
            <h3>Raised By:</h3>
            <span>
              <p> {concern?.raisedBy?.first_name}</p>
              <p> {concern?.raisedBy?.last_name}</p>
            </span>
            <p>{concern?.raisedBy?.email}</p>
          </div>
          <div className="card">
            <h3> Raised Concern:</h3>
            <div className="wrapper">
              <span>
                <h3>Concern Subject:</h3>
                <p>{concern?.subject}</p>
              </span>
              <span>
                <h3>Concern Message:</h3>
                <p>{concern?.message}</p>
              </span>
            </div>
          </div>
          <div className="card">
            <h3>Package Info:</h3>
            <p>Sender Details:</p>
            <div className="wrapper">
              <span>
                <p>Name: {concern?.packageData?.sender?.name}</p>
              </span>
              <span>
                <p>
                  Contact Name: {concern?.packageData?.sender?.contact_name}
                </p>
              </span>
              <span>
                <p>
                  Phone Number: {concern?.packageData?.sender?.phone_number}
                </p>
              </span>
              <span>
                <p>Email: {concern?.packageData?.sender?.email}</p>
              </span>
              <span>
                <p>Address 1: {concern?.packageData?.sender?.address_1}</p>
              </span>
              <span>
                <p>Address 2: {concern?.packageData?.sender?.address_2}</p>
              </span>
              <span>
                <p>Zip Code: {concern?.packageData?.sender?.zip_code}</p>
              </span>
              <span>
                <p>State: {concern?.packageData?.sender?.state}</p>
              </span>
              <span>
                <p>City: {concern?.packageData?.sender?.city}</p>
              </span>
            </div>
          </div>

          <div className="card">
            <p>Receiver Details:</p>
            <div className="wrapper">
              <span>
                <p>Name: {concern?.packageData?.receiver?.name}</p>
              </span>
              <span>
                <p>
                  Contact Name: {concern?.packageData?.receiver?.contact_name}
                </p>
              </span>
              <span>
                <p>
                  Phone Number: {concern?.packageData?.receiver?.phone_number}
                </p>
              </span>
              <span>
                <p>Email: {concern?.packageData?.receiver?.email}</p>
              </span>
              <span>
                <p>Address 1: {concern?.packageData?.receiver?.address_1}</p>
              </span>
              <span>
                <p>Address 2: {concern?.packageData?.receiver?.address_2}</p>
              </span>
              <span>
                <p>Zip Code: {concern?.packageData?.receiver?.zip_code}</p>
              </span>
              <span>
                <p>State: {concern?.packageData?.receiver?.state}</p>
              </span>
              <span>
                <p>City: {concern?.packageData?.receiver?.city}</p>
              </span>
            </div>
          </div>

          <div className="card">
            <p>Items Details:</p>
            <div className="wrapper">
              {concern?.packageData?.items?.map((item, index) => (
                <div key={item._id || index} className="item-info">
                  <span>
                    <p>Item Name: {item.name}</p>
                  </span>
                  <span>
                    <p>Weight: {item.weight}</p>
                  </span>
                  <span>
                    <p>Quantity: {item.quantity}</p>
                  </span>
                  <span>
                    <p>Item Value: {item.items_value}</p>
                  </span>
                </div>
              ))}
            </div>
          </div>

          <div className="card">
            <p>Shipping Details:</p>
            <div className="wrapper">
              <span>
                <p>
                  Shipping Cost:{" "}
                  {concern?.packageData?.shipping_cost
                    ? concern?.packageData?.shipping_cost.toLocaleString(
                        "en-US",
                        {
                          style: "currency",
                          currency: "NGN",
                        }
                      )
                    : null}
                </p>
              </span>
              <span>
                <p>
                  Original Shipping Cost:{" "}
                  {concern?.packageData?.original_shipping_cost
                    ? concern?.packageData?.original_shipping_cost.toLocaleString(
                        "en-US",
                        {
                          style: "currency",
                          currency: "NGN",
                        }
                      )
                    : null}
                </p>
              </span>
              <span>
                <p>
                  Total Discount:{" "}
                  {concern?.packageData?.total_discount
                    ? concern?.packageData?.total_discount.toLocaleString(
                        "en-US",
                        {
                          style: "currency",
                          currency: "NGN",
                        }
                      )
                    : null}
                </p>
              </span>
              <span>
                <p>
                  Discount Percentage:{" "}
                  {concern?.packageData?.discount_percentage}%
                </p>
              </span>
              <span>
                <p>
                  Date Created:{" "}
                  {concern?.packageData?.dateCreated
                    ? new Date(
                        concern?.packageData?.dateCreated
                      ).toLocaleDateString()
                    : "N/A"}
                </p>
              </span>

              <span>
                <p>
                  Estimated Delivery:{" "}
                  {new Date(
                    concern?.packageData?.estimated_delivery_date
                  ).toLocaleDateString()}
                </p>
              </span>
              <span>
                <p>Payment Method: {concern?.packageData?.payment_method}</p>
              </span>
              <span>
                <p>Delivery Method: {concern?.packageData?.delivery_method}</p>
              </span>
              <span>
                <p>
                  Emergency: {concern?.packageData?.isEmergency ? "Yes" : "No"}
                </p>
              </span>
              <span>
                <p>
                  Pickup Required:{" "}
                  {concern?.packageData?.isPickupRequired ? "Yes" : "No"}
                </p>
              </span>
              <span>
                <p>Tracking Number: {concern?.packageData?.tracking_number}</p>
              </span>
            </div>
          </div>

          <div className="card">
            <p>Package Status:</p>
            {concern?.packageData?.status?.map((item, index) => (
              <div className="wrapper" key={item._id || index}>
                <span>
                  <p>Status: {item.status}</p>
                  <p>State: {item.state || "N/A"}</p>
                </span>
                <span>
                  <p>City: {item.city || "N/A"}</p>
                  <p>Received By: {item.receivedBy || "N/A"}</p>
                </span>
                <span>
                  <p>
                    Date:{" "}
                    {item.createdAt
                      ? new Date(item.createdAt).toLocaleDateString()
                      : "N/A"}
                  </p>
                </span>
              </div>
            ))}
          </div>

          <div className="ticket-response">
            <p> Ticket Status ansd Response:</p>
            <span>
              <p>{concern.status}</p>
              <button
                onClick={() => {
                  if (concern.status === "Closed") {
                    setShowClosedMsg(true);
                    setTimeout(() => {
                      setShowClosedMsg(false);
                    }, 5000);
                  } else {
                    setRespondToConcern(true);
                  }
                }}
              >
                Respond to concern
              </button>
              {showClosedMsg && (
                <p style={{ color: "red", fontSize: "14px" }}>
                  This concern has been closed and can no longer be responded
                  to.
                </p>
              )}
            </span>
          </div>
        </div>
      </div>
    </>
  );
}
